import React from 'react';
import PropTypes from 'prop-types';
import NavActions from '../../actions';

export default class EuCookieMessage extends React.PureComponent {
    static propTypes = {
        isEu: PropTypes.bool,
        isAccepted: PropTypes.bool,
        config: PropTypes.object,
        cookies: PropTypes.object
    };

    static contextTypes = {
        globalLinkOnClick: PropTypes.func
    };

    onClick = (e) => {
        const config = this.props.config;
        const href = config.policyUrl;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            this.context.globalLinkOnClick(e, href);
        }
    };

    messageClose = (e) => {
        NavActions.euCookieMessageClose.defer(this.props.cookies);
    }

    render() {
        const config = this.props.config || {};
        const cookieString = config.cookieString || '';
        const policyStrings = cookieString.split('{0}') || [];

        if (this.props.isEu && !this.props.isAccepted) {
            return (
                <div id="euCookie" className="eu-cookie bg-color">
                    <p className="cookie-msg text-color-nonactive">
                        <span>{policyStrings[0] || ''}</span>
                        <a href={config.policyUrl} className="policy-link" onClick={this.onClick}>{config.policyString}</a>
                        <span>{policyStrings[1] || ''}</span>
                    </p>
                    <button id="euCookieAccept" className="cookie-accept accent-bg-color accent-bg-color-hover" onClick={this.messageClose}>
                        <span className="accent-text-color accent-text-color-hover">{config.closeString}</span>
                    </button>
                </div>
            );
        }
        return null;
    }
}
